import type { ReactNode } from 'react';

export function Loader({ text = 'Загружаю…' }: { text?: string }) {
  return <div className="loader">{text}</div>;
}

export function Empty({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="empty">
      <div style={{ fontSize: 34, marginBottom: 8 }}>🌱</div>
      <div className="title">{title}</div>
      {hint ? <div className="hint mt">{hint}</div> : null}
    </div>
  );
}

export function ErrorBanner({ message }: { message: string }) {
  return <div className="error">{message}</div>;
}

export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`card ${className}`.trim()}>{children}</div>;
}

const STATUS_LABELS: Record<string, string> = {
  healthy: 'здоровое',
  attention: 'внимание',
  treatment: 'лечение',
  dormant: 'покой',
  archived: 'архив',
};

export function StatusBadge({ status }: { status: string }) {
  return <span className={`badge ${status}`}>{STATUS_LABELS[status] ?? status}</span>;
}

const PLANT_EMOJI = ['🌿', '🪴', '🌵', '🌱', '🍀'];

export function PlantAvatar({ url, name }: { url: string | null; name: string }) {
  if (url) return <img className="avatar" src={url} alt={name} />;
  const index = name.length % PLANT_EMOJI.length;
  return <div className="avatar">{PLANT_EMOJI[index]}</div>;
}

export function formatDate(value: string | null, withTime = false): string {
  if (!value) return '—';
  const date = new Date(value);
  const options: Intl.DateTimeFormatOptions = withTime
    ? { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }
    : { day: '2-digit', month: 'short' };
  return date.toLocaleDateString('ru-RU', options);
}

export function daysAgo(value: string | null): string {
  if (!value) return '—';
  const diff = Math.floor((Date.now() - new Date(value).getTime()) / 86_400_000);
  if (diff <= 0) return 'сегодня';
  if (diff === 1) return 'вчера';
  if (diff < 5) return `${diff} дня назад`;
  return `${diff} дн. назад`;
}
